module.exports = __webpack_public_path__ + "media/images/txt_forman-ea72c60292adddbd2df36ffeccc63e00.svg";